export default "__VITE_ASSET__c48c60a6__"